import styled from 'styled-components';

export const StyledRequirements = styled('div')`
  .reqs {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
    padding-bottom: 15px;
    gap: 0;
    font-size: 14px;

    div {
      margin: 0;
      display: flex;
      gap: 5px;
      .formats {
        display: flex;
        gap: 5px;
      }
    }

    .req,
    .intl:before {
      content: '• ';
    }
  }
`;

export const StyledFileUploaderForm = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  .file-uploader-title {
    font-weight: 600;
  }

  .ant-form-item-explain-error {
    position: absolute;
    font-size: 10px;
    z-index: 40;
  }

  .desc {
    .ant-input {
      height: 152px;
    }
  }

  .ant-upload-list {
    display: flex;
    padding-top: 30px;
    gap: 20px;
  }
  .social-icons {
    display: flex;
    gap: 20px;

    img {
      cursor: pointer;
    }
  }
  .ant-input-affix-wrapper {
    border-radius: 5px;
  }

  .ant-input {
    border-radius: 5px;
  }

  .time {
    display: flex;
    flex-direction: column;
  }

  .ant-input-number-suffix {
    .unit-suffix {
      height: 100%;
      position: absolute;
      right: 0;
      display: flex;
      min-width: 57px;
      align-items: center;
      justify-content: center;
      border-left: 1px solid ${(props) => props.theme.inputAddonBg};
      background-color: ${(props) => props.theme.inputAddonBg};
    }
  }

  .suffix {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .image-upload.capped {
    display: none;
  }

  .image-upload {
    min-height: 98px;
    .ant-upload-drag {
      background: transparent;
      border: none;
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23C3C3C3FF' stroke-width='2' stroke-dasharray='8' stroke-dashoffset='9' stroke-linecap='square'/%3e%3c/svg%3e");
      border-radius: 4px;
    }

    .ant-upload-drag,
    .ant-upload-btn,
    .ant-upload-drag-container {
      display: flex;
      flex-direction: column;
      width: 431px;
      height: 100px;
      align-items: center;
      justify-content: center;

      .ant-upload-drag-icon {
        margin: 0;
      }
    }
  }

  .requirements {
    ${(props) => {
      if (props.className !== 'multiple') {
        return `
          display: flex;
          align-items: flex-end;
          gap: 100px;
        `;
      }
    }}
    .reqs {
      display: flex;
      flex-direction: column;
      padding-top: 15px;
      padding-bottom: 15px;
      gap: 0;
      p {
        margin: 0;
      }
    }

    .uploader-container {
      align-self: start;
    }
  }

  .scnd-tr {
    min-width: 407px;
    min-height: 38px;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    margin-top: 15px;
  }

  .flex {
    min-width: 261px;
    flex-grow: 1;
    min-height: 38px;
  }

  .checkboxes {
    margin-bottom: 20px;
  }

  .prod-availability {
    border-top: 1px solid ${(props) => props.theme.colorBorder};
    padding-top: 25px;
    border-bottom: 1px solid ${(props) => props.theme.colorBorder};
    padding-bottom: 25px;
  }

  .additional-info {
    padding-top: 25px;

    .chkboxes {
      display: flex;
      flex-direction: row;
      gap: 400px;
      padding-top: 10px;

      .ant-checkbox-group {
        display: flex;
        gap: 10px;
        flex-direction: column;
      }
    }
  }
`;
